import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StoreConsumptionAdapter } from './adapter/store-consumption.adapter';
import { StoreConsumptionItems } from './entity/store-consumption-items.entity';
import { StoreConsumption } from './entity/store-consumption.entity';
import { StoreConsumptionController } from './store-consumption.controller';
import { StoreConsumptionService } from './store-consumption.service';
import { SaleOrderService, saleOrder } from '@gtpl/shared-services/sale-management';
import { EmployeeService, ItemCategoryService, ItemsService, RackPositionService } from '@gtpl/shared-services/masters';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ScheduleModule } from '@nestjs/schedule';
import { PlaceListItems } from './entity/place_list_items.entity';
import { MaterialPreperationRepository } from '../stock/repository/material-preperation-repository';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { IndentForm } from './entity/packing-indent.entity';
import { IndentFormAdapter } from '../indent/indent-form.adapter';
import { EtdWise } from './entity/etd-wise-grid.entity';
import { EtdWiseAdapter } from './adapter/etd-wise.adapter';
import { EtdWiseDataRepository } from './repository/etd-wise-grid.repository';
import { PackingIndentService } from '@gtpl/shared-services/procurement';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([StoreConsumption, StoreConsumptionItems,PlaceListItems,MaterialPreperationRepository,IndentForm,EtdWise,EtdWiseDataRepository]),
    ScheduleModule.forRoot()
  ],
  controllers: [StoreConsumptionController],
  providers: [WhatsAppNotificationService,StoreConsumptionService, StoreConsumptionAdapter, ApplicationExceptionHandler, ItemCategoryService, SaleOrderService, ItemsService,EmployeeService,RackPositionService,WhatsappBroadCastService,IndentFormAdapter,EtdWiseAdapter, PackingIndentService,LogsService],
  exports: [StoreConsumptionService]
})
export class StoreConsumptionModule {}
